import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "flex-none font-sans font-bold break-normal text-gray-700 p-1" }, " 体験・サンプリング追加 ", -1)
const _hoisted_3 = { class: "flex-none p-4 mt-2 rounded shadow bg-white" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "block mt-2" }, "メイン画像", -1)
const _hoisted_5 = { class: "grid grid-cols-1 gap-3" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center justify-center w-full"
}
const _hoisted_7 = { class: "flex flex-col w-full h-32 border-4 border-blue-200 border-dashed hover:bg-gray-100 hover:border-gray-300" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col items-center justify-center pt-7" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "w-8 h-8 text-gray-400 group-hover:text-gray-600",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
    })
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "pt-1 text-sm tracking-wider text-gray-400 group-hover:text-gray-600" }, " Attach a file ")
], -1)
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "top-4 right-4 absolute w-8 h-8 bg-red-400 rounded-full" }
const _hoisted_11 = { class: "text-xs text-pink-600" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "block mt-2" }, "タイトル", -1)
const _hoisted_13 = { class: "grid grid-cols-1 gap-3" }
const _hoisted_14 = { class: "relative" }
const _hoisted_15 = { class: "text-xs text-pink-600" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "block mt-2" }, "対象サロン", -1)
const _hoisted_17 = { class: "grid grid-cols-1 gap-3" }
const _hoisted_18 = { class: "flex flex-wrap" }
const _hoisted_19 = ["id", "onUpdate:modelValue"]
const _hoisted_20 = ["for"]
const _hoisted_21 = { class: "text-xs text-pink-600" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "block mt-2" }, "表示期間", -1)
const _hoisted_23 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_24 = { class: "relative" }
const _hoisted_25 = { class: "text-xs text-pink-600" }
const _hoisted_26 = { class: "relative" }
const _hoisted_27 = { class: "text-xs text-pink-600" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "block mt-2" }, "受け取り可能", -1)
const _hoisted_29 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_30 = { class: "relative" }
const _hoisted_31 = { class: "form-check-label text-sm inline-block text-gray-800 mr-2" }
const _hoisted_32 = { class: "flex-grow p-2 mt-2 rounded shadow bg-white" }
const _hoisted_33 = { class: "text-xs text-pink-600" }
const _hoisted_34 = { class: "flex-none text-right col-span-full mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!
  const _component_editor = _resolveComponent("editor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "m-4",
          onDrop: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onMainImageDropped && _ctx.onMainImageDropped(...args)), ["prevent"])),
          onDragenter: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
          onDragover: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
        }, [
          (!_ctx.main_image_url)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("label", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("input", {
                    type: "file",
                    class: "opacity-0",
                    onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onInputFileChanged && _ctx.onInputFileChanged(...args)))
                  }, null, 32)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.main_image_url)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "relative w-96",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.removeMainImage && _ctx.removeMainImage(...args)))
              }, [
                _createElementVNode("img", { src: _ctx.main_image_url }, null, 8, _hoisted_9),
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_component_fa, {
                    icon: "trash",
                    class: "text-sm text-center text-white mt-2 ml-2"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.main_image_url_error), 1)
        ], 32)
      ]),
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: _normalizeClass(["px-3 py-2 max-w-full w-full focus:outline-none border-gray-200 rounded dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _ctx.title_error }]),
            placeholder: "タイトル",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.title) = $event))
          }, null, 2), [
            [_vModelText, _ctx.title]
          ]),
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.title_error), 1)
        ])
      ]),
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.salons, (salon) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "flex items-center mr-4",
              key: salon.id
            }, [
              _withDirectives(_createElementVNode("input", {
                id: `inline-checkbox-${salon.id}`,
                type: "checkbox",
                "onUpdate:modelValue": ($event: any) => ((salon.is_selected) = $event),
                class: "w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
              }, null, 8, _hoisted_19), [
                [_vModelCheckbox, salon.is_selected]
              ]),
              _createElementVNode("label", {
                for: `inline-checkbox-${salon.id}`,
                class: "ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              }, _toDisplayString(salon.name), 9, _hoisted_20)
            ]))
          }), 128))
        ]),
        _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.salon_ids_error), 1)
      ]),
      _hoisted_22,
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _withDirectives(_createElementVNode("input", {
            type: "date",
            class: _normalizeClass(["px-3 py-2 w-full focus:outline-none border-gray-200 rounded dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _ctx.publish_from_error }]),
            placeholder: "表示期間(開始)",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.publish_from) = $event))
          }, null, 2), [
            [_vModelText, _ctx.publish_from]
          ]),
          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.publish_from_error), 1)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _withDirectives(_createElementVNode("input", {
            type: "date",
            class: _normalizeClass(["px-3 py-2 w-full focus:outline-none border-gray-200 rounded dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _ctx.publish_to_error }]),
            placeholder: "表示期間(終了)",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.publish_to) = $event))
          }, null, 2), [
            [_vModelText, _ctx.publish_to]
          ]),
          _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.publish_to_error), 1)
        ])
      ]),
      _hoisted_28,
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("label", _hoisted_31, [
            _withDirectives(_createElementVNode("input", {
              class: "cursor-pointer",
              type: "checkbox",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.receivable) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.receivable]
            ]),
            _createTextVNode(" 受け取りが可能か ")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createVNode(_component_editor, {
        apiKey: "6q2dpclc7cej6s5lf27smv4shxp5gq17tspjczs8owhanety",
        init: {
          language: 'ja',
          height: 480,
          plugins: 'image code',
          menubar: 'edit insert format forecolor table code',
          toolbar:
            'insertfile undo redo | styleselect | forecolor backcolor | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image pagebreak | code',
          file_picker_types: 'image media',
          file_picker_callback: _ctx.onFilePicked,
        },
        modelValue: _ctx.body,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.body) = $event))
      }, null, 8, ["init", "modelValue"]),
      _createElementVNode("input", {
        type: "file",
        ref: "uploadFile",
        accept: "image/jpeg,image/png",
        style: {"width":"0px"},
        onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onUploadFileChanged && _ctx.onUploadFileChanged(...args)))
      }, null, 544),
      _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.body_error), 1)
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("button", {
        class: "shadow bg-yellow-700 hover:bg-yellow-500 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded",
        type: "button",
        onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSave && _ctx.onSave(...args)), ["prevent"]))
      }, " 登録 ")
    ])
  ]))
}